import { IOnInit, IScope } from "angular";
import { ChangeJournalViewItemServiceComponentConfig } from "./service";

export class ChangeJournalViewComponentItemController implements IOnInit {
  $onInit(): void {}
}
